import { Map } from 'immutable';

import * as t from '../actions/userActionTypes';

const initialState = Map({
  message: null,
  user: {},
  loading: false,
  userNotifications: [],
  cantStudy: false,
  lastNotificationsRequest: 0,
  lastUserNotificationsRequest: 0,
});

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case t.SET_LOADING:
      return state.set('loading', action.value);

    case t.SET_MESSAGE:
      return state.set('message', action.message);

    case t.SET_USER:
      return state.set('user', action.user);

    case t.SET_SUBSCRIPTION:
      const updatedUser = { ...state.get('user') };
      updatedUser.subscription = action.subscription;
      return state.set('user', updatedUser);

    case t.SET_CANT_STUDY:
      return state.set('cantStudy', action.cantStudy);

    case t.SET_LAST_NOTIFICATIONS_REQUEST:
      return state.set('lastNotificationsRequest', action.value);
    case t.SET_LAST_USER_NOTIFICATIONS_REQUEST:
      return state.set('lastUserNotificationsRequest', action.value);

    case t.SET_CHANGE_STUDY_SPEED_SETTINGS:
      const userState = state.get('user');
      userState.userSetting.studySpeed = action.setting;
      return state.set('user', userState);

    case t.SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ:
      return state.setIn(
        ['user', 'userSetting', 'qualDailyQuiz'],
        action.qualId,
      );
    case t.SET_USER_SETTING_QUAL_FOR_DAILY_QUIZ_MESSAGE:
      return state.set('userSettingQualForDailyQuizMessage', action.message);
    default:
      return state;
  }
};

export default reducer;
